import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useContext, useEffect } from 'react';
import { SocketContext } from '../../utils/socket';
import { Trailer } from '../../types';
import Button from '../ui/Button';

enum TrailerLocation {
	PRIMARY = 'PRIMARY',
	SECONDARY = 'SECONDARY',
	RVAC = 'RVAC',
	RVAC2 = 'RVAC2',
	RMAN = 'RMAN',
	OffSiteLot = 'OffSiteLot',
}

type Props = {
	open: boolean;
	editOpen: () => void;
	lotMove: () => void;
	outModal: () => void;
	spotNumber?: number;
	trailerLocation?: TrailerLocation;
	trailer: Trailer | null;
	close: () => void;
	outRequest?: boolean;
};

export function isEmpty(value: string | undefined) {
	if (typeof value !== undefined && value) {
		return true
	}
	return false
}

export default function TempModal({
	open,
	editOpen,
	lotMove,
	close,
	outModal,
	spotNumber = 1,
	trailer,
	trailerLocation = TrailerLocation.RVAC,
	outRequest = true,
}: Props) {
	const socket = useContext(SocketContext);

	useEffect(() => {
		socket.on('getTrailerCheck', (res) => {
			lotMove();
		})
	}, [socket]);

	return (
		<>
			<Transition show={open} as={Fragment}>
				<Dialog
					as="div"
					className="fixed z-10 inset-0 overflow-y-auto"
					static
					open={open}
					onClose={close}
				>
					<div className="min-h-screen px-4 text-center">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" 
							onClick={close}/>
						</Transition.Child>

						{/* This element is to trick the browser into centering the modal contents. */}
						<span className="inline-block h-screen align-middle" aria-hidden="true">
							&#8203;
						</span>
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
								<Dialog.Title
									as="h3"
									className=" text-5xl font-bold font-large leading-6 text-gray-900"
								>
									{trailer?.trailerNumber}
								</Dialog.Title>

								<div className="mt-5">
									<div>
										<span className="text-xl font-bold">Carrier: </span>
										<span className="text-xl">{trailer?.carrier}</span>
									</div>
									<div>
										<span className="text-xl font-bold">Category: </span>
										<span className="text-xl">{trailer?.category}</span>
									</div>
									<div>
										<span className="text-xl font-bold">Comments: </span>
										{isEmpty(trailer?.comments?.toString()) &&
											<textarea className="bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 w-full border border-gray-400 rounded-md px-4 py-2 focus:border-brand-600 focus:ring-brand-500 disabled:opacity-60 disabled:opacity-60 disabled:bg-gray-500 disabled:bg-opacity-20"
												readOnly={true}>
												{trailer?.comments}
											</textarea>
										}
									</div>
								</div>

								<form
									onSubmit={(e) => {
										e.preventDefault();
									}}
								>
									<div className="mt-4 flex">
										<Button onClick={editOpen} type="submit">
											Edit
										</Button>
										{outRequest ? (
											<div className="ml-2">
												<Button onClick={outModal}>Out</Button>
											</div>
										) : null}
										<div className="ml-2">
											<Button onClick={() => {
												socket.emit('checkTrailer', { trailer, isMove: true })
											}}>Move</Button>
										</div>
										<div className="ml-2">
											<Button
												onClick={() => {
													socket.emit('checkTrailer', { trailer, isMove: false })
													close();
												}}
											>
												Depart
											</Button>
										</div>
										<div className="ml-2">
											<Button variant="danger" close={close}>
												Close
											</Button>
										</div>
									</div>
								</form>
							</div>
						</Transition.Child>
					</div>
				</Dialog>
			</Transition >
		</>
	);
}
